import { MessageBar, MessageBarBody, makeStyles, tokens } from '@fluentui/react-components';
import { useT } from '@powerportalspro/react';
import {
  ExportGridButton,
  GridColumn,
  GridColumns,
  GridToolbarItems,
  MainGrid,
  NavigateNewRecordGridButton,
  NavigateOpenRecordGridButton,
} from '@powerportalspro/react-fluent';
import { useMemo } from 'react';
import { ALL_ACCOUNTS_VIEW_ID, getAllAccountsView } from './AccountAndContactCustomViews';

// The accounts, in more columns than fit across the page, so the table scrolls sideways. The
// account's name is pinned to the table's start (`pin="start"`) and its revenue to the end: both
// stay in view while the columns between them scroll under them. With a column pinned to the
// start, the selection column is pinned too. A pinned column needs a width, which each column here
// is given.
//
// Each column's menu pins it to the start or the end, or unpins it, in place of the page's pins; a
// header dragged among the pinned columns is pinned as they are. The grid keeps the user's pins in
// the URL (`persistedStateQueryParameter`), so a link opens with them.

const STRINGS_BASE =
  'components.PowerPortalsPro.Demo.Client.Customizations.Pages.Demos.GridDemos.GridPinnedColumnsMainDemo';

const ACCOUNT_URL = 'demos/account';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: tokens.spacingVerticalMNudge,
  },
});

export function GridPinnedColumnsMainSample() {
  const styles = useStyles();
  const t = useT();

  const accountViews = useMemo(() => [getAllAccountsView()], []);

  return (
    <div className={styles.root}>
      <MessageBar intent="warning" layout="multiline">
        <MessageBarBody>{t(`${STRINGS_BASE}.login-required`)}</MessageBarBody>
      </MessageBar>

      <MainGrid
        tableName="account"
        minHeight="550px"
        maxHeight="550px"
        viewIds={[ALL_ACCOUNTS_VIEW_ID]}
        customViewDefinitions={accountViews}
        defaultViewId={ALL_ACCOUNTS_VIEW_ID}
        persistedStateQueryParameter="accountsState"
      >
        <GridColumns>
          <GridColumn columnName="name" width="220px" pin="start" />
          <GridColumn columnName="accountnumber" width="150px" />
          <GridColumn columnName="telephone1" width="160px" />
          <GridColumn columnName="emailaddress1" width="240px" />
          <GridColumn columnName="websiteurl" width="220px" />
          <GridColumn columnName="address1_city" width="160px" />
          <GridColumn columnName="address1_stateorprovince" width="160px" />
          <GridColumn columnName="address1_country" width="160px" />
          <GridColumn columnName="numberofemployees" width="140px" />
          <GridColumn columnName="primarycontactid" width="200px" />
          <GridColumn columnName="revenue" width="160px" pin="end" />
        </GridColumns>
        <GridToolbarItems>
          <NavigateNewRecordGridButton url={ACCOUNT_URL} />
          <NavigateOpenRecordGridButton urlFor={(record) => `${ACCOUNT_URL}?accountId=${record.id}`} />
          <ExportGridButton />
        </GridToolbarItems>
      </MainGrid>
    </div>
  );
}
